import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function Users() {
  const { userId } = useParams(); // URL-dən istifadəçi ID-ni alırıq
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`https://api.herracim.az/api/user/byUserId/${userId}`);
        if (!response.ok) {
          throw new Error("İstifadəçi tapılmadı");
        }

        const userData = await response.json();
        setUser(userData);
      } catch (error) {
        console.error("Xəta:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  if (loading) {
    return <p>Yüklənir...</p>;
  }

  return (
    <div>
      {user ? (
        <div>
          <h2>{user.fullName}</h2>
          <p>Email: {user.email}</p>
          <p>Telefon: {user.phoneNumber}</p>
        </div>
      ) : (
        <p>İstifadəçi tapılmadı</p>
      )}
    </div>
  );
}

export default Users;
